import { ResourceDataContextProvider } from '@fabric-app/business/resource-detail/components/context/ResourceDataContextProvider';
import { ResourcePreviewListPreview } from '@fabric-app/business/resources/components/ResourcePreview/ResourcePreviewList/preview/ResourcePreviewListItemPreview';
import { getResourceNamePlaceholder } from '@fabric-app/business/resources/utils/getResourceTitle';
import { IconDesktop16Cross } from '@fabric-app/icons/svg';
import type { ResourceDetail } from '@fabric-app/types/resources';
import { cssTextEllipsis } from '@fabric-app/ui/constants/styled-utils';
import { ForcedTheme } from '@fabric-app/ui/theme/ForcedTheme';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { styled } from 'styled-components';

interface SearchSimilarResourceProps {
  resource: ResourceDetail;
  onRemove: () => void;
}
export const SearchSimilarResource = ({ resource, onRemove }: SearchSimilarResourceProps) => {
  return (
    <ResourceDataContextProvider resource={resource}>
      <ForcedTheme colorScheme="dark">
        <Container>
          <ThumbnailImageContainer>
            <ResourcePreviewListPreview />
          </ThumbnailImageContainer>
          <TitleContainer>
            <Title>{resource.name || getResourceNamePlaceholder(resource)}</Title>
            {resource.extension ? <Extension>.{resource.extension}</Extension> : null}
          </TitleContainer>
          <CloseButtonContainer onClick={onRemove}>
            <IconDesktop16Cross />
          </CloseButtonContainer>
        </Container>
      </ForcedTheme>
    </ResourceDataContextProvider>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: black;
  padding: 6px;
  gap: 6px;
  max-width: 320px;
  overflow: hidden;
  margin-left: 4px;
  cursor: initial;
`;

const ThumbnailImageContainer = styled.div`
  width: 34px;
  height: 25px;
  flex-shrink: 0;
  color: ${cssVar['color-text-primary']};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const TitleContainer = styled.div`
  font-size: 13px;
  font-weight: 400;
  color: ${cssVar['color-text-primary']};
  display: flex;
  align-items: center;
  overflow: hidden;
  user-select: none;
`;

const Title = styled.div`
  ${cssTextEllipsis}
`;

const Extension = styled.span`
  opacity: 0.6;
`;

const CloseButtonContainer = styled.div`
  margin-right: 4px;
  color: ${cssVar['color-text-primary']};
  cursor: pointer;
  opacity: 0.5;
  transition: opacity 0.1s ease-in-out;
  &:hover {
    opacity: 1;
  }
`;
